module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "school-item"
  }, [_c('div', {
    staticClass: "item-img"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openschoolDetail(_vm.msg.courseId)
      }
    }
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.msg.picUrl),
      expression: "msg.picUrl"
    }],
    attrs: {
      "alt": _vm.msg.courseTitle
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item-brief"
  }, [_c('div', {
    staticClass: "school-title",
    domProps: {
      "innerHTML": _vm._s(_vm.msg.courseTitle)
    }
  }, [_vm._v(_vm._s(_vm.msg.courseTitle))]), _vm._v(" "), _c('div', {
    staticClass: "school-sub-title"
  }, [_vm._v(_vm._s(_vm.msg.courseSubTitle))]), _vm._v(" "), _c('div', {
    staticClass: "school-sub-time"
  }, [_vm._v("\n      " + _vm._s(_vm.msg.courseTime) + "\n      "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.openschoolDetail(_vm.msg.courseId)
      }
    }
  }, [_c('y-button', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "text": "阅读更多"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51477c7d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/schoolItem.vue
// module id = 637
// module chunks = 0